var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPrepaid20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 3a1 1 0 0 1 .993.883L17 4v14l-1.75-1.5L13.5 18l-1.75-1.5L10 18l-1.75-1.5L6.5 18l-1.75-1.5L3 18V4a1 1 0 0 1 .883-.993L4 3zm-2 9h-2a.5.5 0 0 0-.09.992L12 13h2a.5.5 0 0 0 .09-.992zm0-3H6a.5.5 0 0 0-.09.992L6 10h8a.5.5 0 0 0 .09-.992zm0-3H6a.5.5 0 0 0-.09.992L6 7h8a.5.5 0 0 0 .09-.992z"
})));
export default SvgIcPrepaid20X20;